import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Sends a GA4 page_view on every client-side route change.
 * Waits a tick so react-helmet-async has swapped the document title.
 */
const AnalyticsTracker = () => {
  const location = useLocation();
  // gtag.js sends the first page_view itself on config; skip it here.
  const isFirstRoute = useRef(true);

  useEffect(() => {
    if (isFirstRoute.current) {
      isFirstRoute.current = false;
      return;
    }
    const timer = window.setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 100);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
